import { Pipe, PipeTransform } from '@angular/core';
import { Assessment, BbtData, NhptData } from '../services/model';

@Pipe({
  name: 'assessmentScoreTarget',
  standalone: true,
})
export class AssessmentScoreTargetPipe implements PipeTransform {
  damageLevels = [
    { icf: 4, min: 96, max: 100, color: '#ff0000a8' }, // Schädigung voll ausgeprägt
    { icf: 3, min: 50, max: 95, color: '#f5363975' }, // Schädigung erheblich ausgeprägt
    { icf: 2, min: 25, max: 49, color: 'orange' }, // Schädigung mäßig ausgeprägt
    { icf: 1, min: 5, max: 24, color: '#cdb832bd' }, // Schädigung leicht ausgeprägt
    { icf: 0, min: 0, max: 4, color: 'lightgray' }, // Schädigung nicht vorhanden
  ];

  transform(assessment: Assessment | undefined, side: 'left' | 'right' | 'none' = 'none'): string | number {
    if (assessment) {
      if (assessment.type === 'ARAT') {
        //@TODO -> Zielwerttabelle! PatientenDaten als Signal injecten! Pipe dann pure:false stellen!
        return '57 Pkt.';
      } else if (assessment.type === 'CUSTOM') {
        return '100 %';
      } else if (assessment.type === 'BBT') {
        const data = assessment.data as BbtData;
        let norm = 0;
        if (side === 'left') {
          norm = data.bbt.norm_left ?? 100;
        }
        if (side === 'right') {
          norm = data.bbt.norm_right ?? 100;
        }
        return norm + ' Bl.';
      } else if (assessment.type === 'BBS') {
        return '56 Pkt.';
      } else if (assessment.type === 'FGA') {
        return '30 Pkt.';
      } else if (assessment.type === 'TUG') {
        return '9 s';
      } else if (assessment.type === 'NHPT') {
        const data = assessment.data as NhptData;
        let norm = 0;
        if (side === 'left') {
          norm = data.nhpt.norm_left ?? 100;
        }
        if (side === 'right') {
          norm = data.nhpt.norm_right ?? 100;
        }
        return Math.round(norm).toLocaleString('de-DE') + ' s';
      } else {
        return 'Fehlt!';
      }
    } else {
      return 'Assessment nicht gefunden!';
    }
  }
}
